import "../../../define/i18n.js";
import { registerIcons } from "../../../icons/element/register/index.js";
import { airPlayEnterIcon } from "../../../icons/dist/html/compat/airplay-enter.js";
import { airPlayExitIcon } from "../../../icons/dist/html/compat/airplay-exit.js";
import { captionsOffIcon } from "../../../icons/dist/html/compat/captions-off.js";
import { captionsOnIcon } from "../../../icons/dist/html/compat/captions-on.js";
import { castEnterIcon } from "../../../icons/dist/html/compat/cast-enter.js";
import { castExitIcon } from "../../../icons/dist/html/compat/cast-exit.js";
import { checkIcon } from "../../../icons/dist/html/compat/check.js";
import { fullscreenEnterIcon } from "../../../icons/dist/html/compat/fullscreen-enter.js";
import { fullscreenExitIcon } from "../../../icons/dist/html/compat/fullscreen-exit.js";
import { pauseIcon } from "../../../icons/dist/html/compat/pause.js";
import { pipEnterIcon } from "../../../icons/dist/html/compat/pip-enter.js";
import { pipExitIcon } from "../../../icons/dist/html/compat/pip-exit.js";
import { playIcon } from "../../../icons/dist/html/compat/play.js";
import { restartIcon } from "../../../icons/dist/html/compat/restart.js";
import { spinnerIcon } from "../../../icons/dist/html/compat/spinner.js";
import { volumeHighIcon } from "../../../icons/dist/html/compat/volume-high.js";
import { volumeLowIcon } from "../../../icons/dist/html/compat/volume-low.js";
import { volumeOffIcon } from "../../../icons/dist/html/compat/volume-off.js";
import "../../../define/ui/container.js";
import "../../../define/ui/poster.js";
import "../../../define/ui/buffering-indicator.js";
import "../../../define/ui/error-dialog.js";
import "../../../define/ui/dialog-backdrop.js";
import "../../../define/ui/dialog-popup.js";
import "../../../define/ui/dialog-title.js";
import "../../../define/ui/dialog-description.js";
import "../../../define/ui/dialog-close.js";
import "../../../define/ui/title.js";
import "../../../define/ui/controls.js";
import "../../../define/ui/controls-backdrop.js";
import "../../../define/ui/controls-content.js";
import "../../../define/ui/tooltip-group.js";
import "../../../define/ui/controls-group.js";
import "../../../define/ui/airplay-button.js";
import "../../../define/ui/tooltip.js";
import "../../../define/ui/tooltip-label.js";
import "../../../define/ui/tooltip-shortcut.js";
import "../../../define/ui/cast-button.js";
import "../../../define/ui/pip-button.js";
import "../../../define/ui/fullscreen-button.js";
import "../../../define/ui/play-button.js";
import "../../../define/ui/slider-track.js";
import "../../../define/ui/slider-fill.js";
import "../../../define/ui/slider-thumb.js";
import "../../../define/ui/mute-button.js";
import "../../../define/ui/volume-popover.js";
import "../../../define/ui/volume-slider.js";
import "../../../define/ui/captions-button.js";
import "../../../define/ui/menu.js";
import "../../../define/ui/menu-content.js";
import "../../../define/ui/menu-radio-item.js";
import "../../../define/ui/menu-item-indicator.js";
import "../../../define/ui/captions-radio-group.js";
import "../../../define/ui/hotkey.js";
import "../../../define/ui/gesture.js";
import "../../../define/ui/status-announcer.js";
import "../../../define/ui/volume-indicator.js";
import "../../../define/ui/volume-indicator-fill.js";
import "../../../define/ui/volume-indicator-value.js";
import "../../../define/ui/status-indicator.js";
import "../../../define/ui/status-indicator-value.js";
import "../../../define/ui/live-button.js";
//#region src/internal/skins/compat-live-video/register.ts
registerIcons("compat", {
	"airplay-enter": airPlayEnterIcon,
	"airplay-exit": airPlayExitIcon,
	"captions-off": captionsOffIcon,
	"captions-on": captionsOnIcon,
	"cast-enter": castEnterIcon,
	"cast-exit": castExitIcon,
	check: checkIcon,
	"fullscreen-enter": fullscreenEnterIcon,
	"fullscreen-exit": fullscreenExitIcon,
	pause: pauseIcon,
	"pip-enter": pipEnterIcon,
	"pip-exit": pipExitIcon,
	play: playIcon,
	restart: restartIcon,
	spinner: spinnerIcon,
	"volume-high": volumeHighIcon,
	"volume-low": volumeLowIcon,
	"volume-off": volumeOffIcon
});
//#endregion

//# sourceMappingURL=register.js.map